import type { NotificationAudience } from '@package/drizzle/schema'

interface ReadStateInput {
  audience: NotificationAudience
  readAt: Date | null
  seenAt: Date | null
  lastActivityAt: Date
}

/**
 * A recipient row is unread until opened.
 * An actor row is unread when the event has had activity since the sender last looked.
 */
export function isUnread({ audience, readAt, seenAt, lastActivityAt }: ReadStateInput): boolean {
  if (audience === 'RECIPIENT') return readAt === null
  if (seenAt === null) return true
  return lastActivityAt.getTime() > seenAt.getTime()
}

/**
 * The badge counts RECIPIENT rows only — see decision 8 in the spec.
 * Sender read-progress is visible on the card but never lights the badge.
 */
export const BADGE_AUDIENCE = 'RECIPIENT' as const
